export const GET_LIVE_ONGOING_COURSES = "GET_LIVE_ONGOING_COURSES" 